angular.module('app').controller('BarcodeCtrl', function($mdDialog, photo, parent, missing, appUtils, $http, $route, $rootScope, PhotoUtils) {
    "ngInject";

    var main = this;
    main.photoUtils = PhotoUtils;
    main.photo = photo;
    main.parent = parent;
    main.missing = missing;
    main.search_event_only = true;
    main.addType = 'existing';
    main.chosen = main.photo.signup;
    main.franchiseId = main.parent.franchiseId || $rootScope.franchiseSwitcher.activeFranchise();
    main.event_id = $route.current.params.event_id || main.parent.item.event.id;
    main.subject = {
        'event_id': main.event_id,
        'answers': {},
        'contacts': []
    };

    main.addNewSubject = function() {
        return $http({
            'method': 'POST',
            'url': '/api/v1/admin/subject_signup',
            'data': main.subject
        }).then(
            function(response) {
                var target = main.missing ? 'missing_barcode' : 'barcode';
                main.photo[target]= response.data.id;
                main.photo.signup = response.data;
                $mdDialog.hide();
            }
        );
    };

    main.save = function() {
        if(main.addType == 'new') {
            return main.addNewSubject();
        } else {
            var target = main.missing ? 'missing_barcode' : 'barcode';
            main.photo.barcode_method = 'manual';
            main.photo[target] = main.chosen.id;
            main.photo.signup = main.chosen;
            $mdDialog.hide();
        }
    };

    main.cancel = $mdDialog.cancel;

    main.search = function(text) {
        if(text) {
            var params = {'q': text};
            if(main.search_event_only) {
                params.event_id = main.event_id;
            }
            return $http({
                'method': 'GET',
                'url': '/api/v1/admin/event_signup/barcode_search',
                'params': params
            }).then(
                function(response) {
                    return response.data.objects;
                }
            );
        }

        return [];
    };


});
